const validationReporter = require('../helpers/validationReporter');
const { configureWorkspace } = require('../blockDefinition/blocklyWorkspace');
module.exports = async function metadataFromWorkspace(blocklyJson, subSet, namespaces, notificationHandler) {
    validationReporter.setValidationReporter(notificationHandler);
    // // JIT loading to delay using blockly until needed
    const Blockly = require('blockly');
    try {
        //TODO: initialize namespace/relation methods?
        const toolbox = configureWorkspace(subSet, namespaces);
        const headlessWorkspace = new Blockly.Workspace(
            Blockly.Options({
                collapse: true,
                comments: false,
                disable: true,
                maxBlocks: Infinity,
                trashcan: true,
                horizontalLayout: false,
                toolboxPosition: 'start',
                css: true,
                media: 'https://blockly-demo.appspot.com/static/media/',
                rtl: false,
                scrollbars: true,
                sounds: true,
                oneBasedIndex: true,
                grid: { spacing: 20, length: 1, colour: '#888', snap: true },
                move: {
                    scrollbars: {
                        horizontal: true,
                        vertical: true
                    },
                    drag: true,
                    wheel: true
                },
                zoom: {
                    controls: true,
                    wheel: true,
                    startScale: 1.0,
                    maxScale: 3,
                    minScale: 0.3,
                    scaleSpeed: 1.2,
                    pinch: true
                },
                toolbox
            })
        );
        Blockly.serialization.workspaces.load(blocklyJson, headlessWorkspace);

        const metadata = Blockly.JavaScript.workspaceToCode(headlessWorkspace);
        return { status: 'success', result: JSON.parse(metadata) };
    } catch (err) {
        notificationHandler(err);
        const { stack, message } = err;
        return { status: 'fail', result: { stack, message } };
    }
};
